// extracted by mini-css-extract-plugin
export default {"list":"brand-collapsible-card_list__vjBZs","listItem":"brand-collapsible-card_listItem__X-IHv","card":"brand-collapsible-card_card__vDAWa"};